/* eslint-disable no-shadow */
export enum FieldNameEnum {
  currentFirm = "currentFirm",
  currentAccount = "currentAccount",
  currentAccountType = "currentAccountType",
  initialFundingDate = "initialFundingDate",
  toAccountType = "toAccountType",
  rothYear = "rothYear",
  rothPortion = "rothPortion",
  transferInstructions = "transferInstructions",
  transferDollarAmount = "transferDollarAmount",
  transferDollarEstimate = "transferDollarEstimate",
  transferPercent = "transferPercent",
  firstName = "firstName",
  lastName = "lastName",
  birthDate = "birthDate",
  ssn = "ssn",
  email = "email",
  primaryPhone = "primaryPhone",
  secondaryPhone = "secondaryPhone",
  byo = "byo",
  fund1 = "fund1",
  fund1Code = "fund1Code",
  fund1Percent = "fund1Percent",
  fund2 = "fund2",
  fund2Code = "fund2Code",
  fund2Percent = "fund2Percent",
  fund3 = "fund3",
  fund3Code = "fund3Code",
  fund3Percent = "fund3Percent",
  fund4 = "fund4",
  fund4Code = "fund4Code",
  fund4Percent = "fund4Percent",
  transferToSame = "transferToSame",
  signature = "signature"
}
/* eslint-enable no-shadow */
